import {
  BzitSearchParameters,
  BzitVehicleDetails,
  Result,
  SearchParams,
  SearchResult,
  ServiceResult
} from '../../bzit';
import { mkFetcher } from '../../caching/fetcher';
import * as SearchParametersService from '../../helper/fetch/SearchParametersService';
import * as VehicleDetailService from '../../helper/fetch/VehicleDetailService';
import * as SearchService from '../../helper/fetch/SearchService';

export const getVehicleDetails = mkFetcher<
  VehicleDetailService.GetVehicleDetailsArgs,
  Result<BzitVehicleDetails>
>({
  fetcher: VehicleDetailService.getVehicleDetails,
  hasher: ({ vehicleId, currency = 'EUR' }) =>
    `VehicleDetailService.getVehicleDetails('${vehicleId}', '${currency}')`,
  predicate: ({ success }) => success,
});

export const getParameters = mkFetcher<
  SearchParametersService.GetParametersArgs,
  ServiceResult<BzitSearchParameters>
>({
  fetcher: SearchParametersService.getParameters,
  hasher: ({ countryId }: SearchParametersService.GetParametersArgs) =>
    `SearchParametersService.getParameters('${countryId || ''}')`,
  predicate: ({ success }) => success,
});

export const searchVehicles = mkFetcher<
  SearchParams,
  ServiceResult<SearchResult>
>({
  fetcher: SearchService.search,
  hasher: (params) =>
    `SearchService.search(${JSON.stringify(params)})`,
  predicate: ({ success }) => success,
  lifetime: () => 60000,
});
